// Utilities
import { defineStore } from 'pinia';
import axios from '@axios';
import { News } from '@/composables/useNews';

export const useAppStore = defineStore('app', {
    state: () => ({
        locale: 'pt',
        _isSidebarOpen: false,
        menus: [],
        industries: [],
        solutions: [],
        products: [],
        aboutUs: null as any,
        ourIdentity: null as any,
        recognition: null as any,
        team: [],
        contacts: null as any,
        homepage: null as any,
        clients: [],
        testimonies: [],
        careers: null as any,
        ioacademy: null as any,
        workAreas: [],
        openPositions: [],
        studentTestimonies: [],
        finishedLoading: false,
        news: [] as News[],
        termsConditions: null as any,
        privacyPolicy: null as any,
        newsletter: null as any,
        newsAllPage: null as any,
        _hasUserChangedLocale: false,
    }),
    getters: {
        getLocale(): string {
            return this.locale;
        },
        isSidebarOpen(): boolean {
            return this._isSidebarOpen;
        },
        getMenus(): any[] {
            return this.menus;
        },
        getIndustries(): any[] {
            return this.industries;
        },
        getIndustryBySlug: (state) => (slug: string) => {
            return state.industries.find((industry: any) => industry.slug === slug);
        },
        hasFinishedLoading(): boolean {
            return this.finishedLoading;
        },
        getSolutions(): any[] {
            return this.solutions;
        },
        getSolutionBySlug: (state) => (slug: string) => {
            return state.solutions.find((solution: any) => solution.slug === slug);
        },
        getProducts(): any[] {
            return this.products;
        },
        getProductBySlug: (state) => (slug: string) => {
            return state.products.find((product: any) => product.slug === slug);
        },
        getAboutUs(): any {
            return this.aboutUs;
        },
        getTeam(): any[] {
            return this.team;
        },
        getOurIdentity(): any {
            return this.ourIdentity;
        },
        getRecognition(): any {
            return this.recognition;
        },
        getContacts(): any {
            return this.contacts;
        },
        getHomepage(): any {
            return this.homepage;
        },
        getClients(): any[] {
            return this.clients;
        },
        getTestimonies(): any[] {
            return this.testimonies;
        },
        getNews(): any[] {
            return this.news;
        },
        getCareers(): any {
            return this.careers;
        },
        getIOAcademy(): any {
            return this.ioacademy;
        },
        getWorkAreas(): any[] {
            return this.workAreas;
        },
        getOpenPositions(): any[] {
            return this.openPositions;
        },
        getStudentTestimonies(): any[] {
            return this.studentTestimonies;
        },
        getTermsConditions(): any {
            return this.termsConditions;
        },
        getPrivacyPolicy(): any {
            return this.privacyPolicy;
        },
        getNewsletter(): any {
            return this.newsletter;
        },
        getRecentNews: (state) => (numberOfNews: number) => {
            return state.news.sort((a: News, b: News) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, numberOfNews);
        },
        getNewsAllPage(): any {
            return this.newsAllPage;
        },
        hasUserChangedLocale(): boolean {
            return this._hasUserChangedLocale;
        },
    },
    actions: {
        setLocale(locale: string) {
            this.locale = locale;
        },
        setHasUserChangedLocale(value: boolean) {
            this._hasUserChangedLocale = value;
        },
        setIsSidebarOpen(value: boolean) {
            this._isSidebarOpen = value;
        },
        async fillStore() {
            try {
                // get locale
                const locale = this.getLocale;
                const { data } = await axios.get(`/site?locale=${locale}`);

                this.aboutUs = data.aboutUs;
                this.careers = data.careers;
                this.clients = data.clients;
                this.contacts = data.contact;
                this.homepage = data.homepage;
                this.industries = data.industries;
                this.ioacademy = data.ioacademy;
                this.menus = data.menus;
                this.news = data.news;
                this.openPositions = data.openPositions;
                this.ourIdentity = data.ourIdentity;
                this.privacyPolicy = data.privacyPolicy;
                this.products = data.products;
                this.recognition = data.recognition;
                this.solutions = data.solutions;
                this.studentTestimonies = data.studentTestimonies;
                this.team = data.team;
                this.termsConditions = data.termsConditions;
                this.testimonies = data.testimonies;
                this.workAreas = data.workAreas;
                this.newsletter = data.newsletter;
                this.newsAllPage = data.newsAllPage;
            } catch (error) {
                console.error('Could not fetch site', error);
            }

            this.finishedLoading = true;
        },
    },
    persist: {
        pick: ['locale'],
    },
});
